import { JObject } from "../../../../../common/data/models";
import { DateUtils } from "../../../../../helpers/date";
import { ImportStoreProductTaskDto } from "../../domain"
import { ImportStoreProductTask } from "../models";

export const ImportTaskMapper = {
    /**
     * Create cart model from json object
     * @param json
     * @returns {ImportTask}
     */
    fromJson: (json?: JObject): ImportStoreProductTask => {
        return {
            fileId: json?.fileId,
            importStoreProductTaskId: json?.importStoreProductTaskId,
            siteId: json?.siteId,
            status: json?.status,
            storeId: json?.storeId,
            storeName: json?.storeName,
            duration: json?.duration,
            createdAt: DateUtils.fromISO(json?.createdAt)
        }
    },

    /**
     *
     */
    toJson: (model: ImportStoreProductTask): JObject => {
        return {
            ...model,
        };
    },

    /**
     * Create model from json object
     * @param dto
     * @returns {ImportTaks}
     */
    fromDto: (dto: ImportStoreProductTaskDto): ImportStoreProductTask => {
        return {
            fileId: dto.fileId,
            importStoreProductTaskId: dto.importStoreProductTaskId,
            siteId: dto.siteId,
            status: dto.status,
            storeId: dto.storeId,
            storeName: dto.storeName,
            duration: dto.duration,

        }
    },

    /**
     *
     */
    toDto: (model: ImportStoreProductTask): ImportStoreProductTaskDto => {
        return {
            fileId: model.fileId,
            importStoreProductTaskId: model.importStoreProductTaskId,
            siteId: model.siteId,
            status: model.status,
            storeId: model.storeId,
            storeName: model.storeName,
            duration: model.duration,
            createdAt: model.createdAt
        };
    },
}
